import { useEffect } from "react";
import { Link } from "react-router-dom";
import assets from "../assets/assets";

const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen py-8 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="flex justify-center mb-6">
            <img
              src={assets.logo01}
              alt="Grainly Logo"
              className="h-16 w-auto"
            />
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Terms of Service
          </h1>
          <p className="text-gray-600">
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-md p-8 space-y-8">
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              1. Acceptance of Terms
            </h2>
            <p className="text-gray-700 leading-relaxed">
              By accessing and using Grainly's services, you accept and agree to
              be bound by the terms and provision of this agreement. If you do
              not agree to abide by the above, please do not use this service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              2. Product Information
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              We strive to provide accurate product information, including:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Product descriptions and specifications</li>
              <li>Pricing and availability</li>
              <li>Origin and quality details</li>
              <li>Nutritional information where applicable</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              3. Orders and Payment
            </h2>
            <div className="space-y-4">
              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  Order Processing
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  All orders are subject to acceptance and availability. We
                  reserve the right to refuse or cancel any order for any
                  reason.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  Payment Methods
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  We accept Cash on Delivery (COD) and online payment methods.
                  All prices are in Indian Rupees (INR).
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              4. Delivery Policy
            </h2>
            <div className="space-y-4">
              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  Delivery Area
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  We currently deliver within a specified radius from our shop
                  location. Delivery charges may apply based on distance.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  Delivery Time
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  We aim to deliver orders within 24-48 hours. Delivery times
                  may vary based on location and product availability.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              5. Return and Refund Policy
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Due to the nature of food products, we have specific return
              policies:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Returns accepted only for damaged or defective products</li>
              <li>Claims must be made within 24 hours of delivery</li>
              <li>Refunds processed within 5-7 business days</li>
              <li>Products must be in original packaging</li>
            </ul>
          </section>

          {/* <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              6. Quality Assurance
            </h2>
            <p className="text-gray-700 leading-relaxed">
              We are committed to providing high-quality rice products. All
              products are sourced from trusted suppliers and undergo quality
              checks before delivery.
            </p>
          </section> */}

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              7. User Responsibilities
            </h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Provide accurate delivery information</li>
              <li>Be available to receive deliveries</li>
              <li>Inspect products upon delivery</li>
              <li>Report any issues promptly</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              8. Limitation of Liability
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Grainly shall not be liable for any indirect, incidental, special,
              consequential, or punitive damages resulting from your use of our
              services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              9. Changes to Terms
            </h2>
            <p className="text-gray-700 leading-relaxed">
              We reserve the right to modify these terms at any time. Changes
              will be effective immediately upon posting on our website.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              10. Contact Information
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              For questions about these Terms of Service, please visit our
              contact page:
            </p>
            <Link
              to="/contact"
              onClick={() => window.scrollTo(0, 0)}
              className="inline-flex items-center bg-[#305669] text-white px-6 py-3 rounded-lg hover:bg-[#1785A] transition-colors duration-200 font-medium shadow-md hover:shadow-lg"
            >
              Visit Contact Page
            </Link>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
